/**
 * Static marketplace agents data.
 * Each agent maps to a route: /marketplace/:slug
 */
const marketplaceAgents = [
  {
    id: "customer-support",
    slug: "customer-support",
    name: "Customer Support",
    description: "Resolves tickets, answers FAQs, escalates to humans",
    price: "$99/mo",
    setupFee: null,
    href: "/marketplace/customer-support",
    channels: ["WhatsApp", "Telegram", "Email", "Discord"],
    features: [
      "Auto-resolve tickets",
      "Smart escalation",
      "Knowledge base integration",
      "Multi-language support",
    ],
    cta: "View agent",
  },
  {
    id: "ecommerce",
    slug: "ecommerce",
    name: "E-Commerce",
    description: "Manages orders, responds customers, tracks inventory",
    price: "$149/mo",
    setupFee: null,
    href: "/marketplace/ecommerce",
    channels: ["WhatsApp", "Instagram", "Email"],
    features: [
      "Order management",
      "Customer support",
      "Inventory tracking",
      "Abandoned cart recovery",
    ],
    cta: "View agent",
  },
  {
    id: "real-estate",
    slug: "real-estate",
    name: "Real Estate",
    description: "Qualifies leads 24/7, schedules visits, sends listings",
    price: "$197/mo",
    setupFee: null,
    href: "/marketplace/real-estate",
    channels: ["WhatsApp", "Instagram", "Facebook"],
    features: [
      "Lead qualification",
      "Visit scheduling",
      "Listing distribution",
      "Follow-up automation",
    ],
    cta: "View agent",
  },
  {
    id: "marketing-agencies",
    slug: "marketing-agencies",
    name: "Marketing Agencies",
    description: "Posts content, responds DMs, monitors mentions",
    price: "$249/mo",
    setupFee: null,
    href: "/marketplace/marketing-agencies",
    channels: ["Instagram", "X/Twitter", "Facebook", "LinkedIn"],
    features: [
      "Content scheduling",
      "DM management",
      "Mention monitoring",
      "Analytics dashboard",
    ],
    cta: "View agent",
  },
  {
    id: "consultancy",
    slug: "consultancy",
    name: "Consultancy",
    description: "Qualifies leads, schedules meetings, researches proposals",
    price: "$149/mo",
    setupFee: null,
    href: "/marketplace/consultancy",
    channels: ["Email", "Telegram", "WhatsApp"],
    features: [
      "Lead triage",
      "Meeting scheduling",
      "Proposal research",
      "CRM integration",
    ],
    cta: "View agent",
  },
];

export default marketplaceAgents;
